import Image from "next/image";
import VideoOne from "../video/video-provider";
import TestimonialSliderOne from "./testimonial-slider-1";
import shape_1 from "@/assets/img/testimonial/testimonial-shape-1.svg";
import { useTranslation } from "react-i18next";

export default function TestimonialOne() {
  const { t } = useTranslation();
  const backgroundImage = 'url("/assets/img/bg/testimonial-bg.webp")';

  return (
    <section
      className="testimonial-area tp-testimonial-bg fix p-relative red-bg"
      aria-label="Architectural view of Al-Hussein Technical University buildings"
      style={{
        backgroundImage,
        backgroundPosition: "left top",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="tp-testimonial-themebg">
        <span></span>
      </div>
      <div className="container">
        <div className="row align-items-center testimonial">
          <div className="col-lg-6">
            <div className="tp-video-wrap d-flex">
              <div className="tp-video-icon text-center">
                <VideoOne
                  cls="video-border-animation"
                  buttonColor=""
                  videoId="Ke3715hxISs"
                  home
                >
                  <span>
                    <svg
                      width="16"
                      height="20"
                      viewBox="0 0 16 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 1.83167C0 1.0405 0.875246 0.562658 1.54076 0.990487L14.6915 9.44454C15.3038 9.83817 15.3038 10.7333 14.6915 11.1269L1.54076 19.5809C0.875246 20.0088 0 19.5309 0 18.7398V1.83167Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </VideoOne>
                <p>{t("know_more_about_htu")}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="tp-testimonial-wrapper wow fadeInRight"
              data-wow-delay=".3s"
            >
              <div className="tp-testimonial-shape">
                <div className="tp-testimonial-shape-1">
                  <Image
                    src={shape_1}
                    alt="testimonial-shape"
                    width={70}
                    height={70}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
              <TestimonialSliderOne />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
